import { Button } from '@factorialco/deprecated-design-system'
import { CreateBenefitsChildcareRequestDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useBenefitModals } from 'modules/benefits/components/benefitModals/useBenefitModals'

import { closeModal } from '../actions'

export const ChildcareRequest = () => {
  const {
    company: { id: companyId },
    employee,
  } = useCurrentSession()

  const { dispatch } = useBenefitModals()

  const [createBenefitsChildcareRequest] = useMutation(CreateBenefitsChildcareRequestDocument, {
    extractorFn: (data) => data?.benefitsMutations?.createBenefitsChildcareRequest,
  })

  const onSubmit = async () => {
    if (!employee) {
      return
    }

    const result = await createBenefitsChildcareRequest({
      variables: {
        companyId,
        employeeId: employee.id,
      },
    })

    const handled = handleResult(result, (_errors) => {})

    if (handled.success) {
      track(trackingEvents.benefits.requestChildcareBenefit)
      dispatch(closeModal())

      window.open(handled.data?.childcareRequest?.childcareUrl, '_blank', 'noopener,noreferrer')
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('benefits.flash_messages.error'),
        time: 2000,
      })
    }

    return handled
  }

  return (
    <Modal
      illustration="add-block"
      title={i18n.t('benefits.homepage.request_benefit.title')}
      description={i18n.t('benefits.homepage.request_benefit.description')}
      onClose={() => dispatch(closeModal())}
      footer={
        <Button type="negative" onClick={onSubmit} iconName="external link">
          {i18n.t('common.start')}
        </Button>
      }
    />
  )
}
